import { boolean, object, string } from 'yup'

const GolfLocationsPrizeDrawSchema = object().shape({
  first_name: string()
    .required('First name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,50}$/,
      'First name can only contain letters and basic punctuation',
    )
    .min(2, 'First name must be at least 2 characters')
    .max(50, 'First name must be at most 50 characters')
    .trim(),
  last_name: string()
    .required('Last name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,50}$/,
      'Last name can only contain letters and basic punctuation',
    )
    .min(2, 'Last name must be at least 2 characters')
    .max(50, 'Last name must be at most 50 characters')
    .trim(),
  tel: string()
    .required('Phone number is required')
    .matches(/^\d{7,11}$/, {
      message: 'Please enter a valid telephone number',
      excludeEmptyString: true,
    })
    .trim(),
  email: string()
    .required('Email is required')
    .matches(
      /^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/,
      'Email must be a valid email address',
    )
    .max(255)
    .trim(),
  plus_one: boolean().required(),
  dietary_requirements: string().trim(),
  guest_first_name: string().when('plus_one', {
    is: (value) => [true].includes(value),
    then: (rule) =>
      rule
        .required('First name is required')
        .matches(
          /^[A-Za-z-.,'` ]{1,50}$/,
          'First name can only contain letters and basic punctuation',
        )
        .min(2, 'First name must be at least 2 characters')
        .max(50, 'First name must be at most 50 characters')
        .trim(),
  }),
  guest_last_name: string().when('plus_one', {
    is: (value) => [true].includes(value),
    then: (rule) =>
      rule
        .required('Last name is required')
        .matches(
          /^[A-Za-z-.,'` ]{1,50}$/,
          'Last name can only contain letters and basic punctuation',
        )
        .min(2, 'Last name must be at least 2 characters')
        .max(50, 'Last name must be at most 50 characters')
        .trim(),
  }),
  guest_driving: string().when('plus_one', {
    is: (value) => [true].includes(value),
    then: (rule) => rule.required(),
  }),
  guest_reg: string().trim(),
  guest_vehicle_make: string().trim(),
  guest_vehicle_model: string().trim(),
  guest_dietary_requirements: string().trim(),
  is_lexus: boolean(),
  campaign_response_code: string().uppercase().trim(),
  campaign_code: string().uppercase().trim(),
  consent: object({
    user: boolean(),
    profile: boolean(),
  }),
})

export default GolfLocationsPrizeDrawSchema
